import enTranslations from '../locales/en.json';
import hiTranslations from '../locales/hi.json';
import saTranslations from '../locales/sa.json';

export const translations = {
	en: {
		code: "en",
		name: "English",
		nativeName: "English",
		translations: enTranslations,
	},
	hi: {
		code: "हिं",
		name: "Hindi",
		nativeName: "हिंदी",
		translations: hiTranslations,
	},
	sa: {
		code: "सं",
		name: "Sanskrit",
		nativeName: "संस्कृतम्",
		translations: saTranslations,
	},
}

export const getTranslation = (language, key, params = {}) => {
  try {
    const keys = key.split('.');
    let result = translations[language.code]?.translations;
    
    for (const k of keys) {
      result = result?.[k];
      if (result === undefined) return key;
    }
    
    if (typeof result === 'string') {
      return Object.entries(params).reduce((str, [param, value]) => {
        return str.replace(new RegExp(`{{${param}}}`, 'g'), value);
      }, result);
    }
    
    return result;
  } catch (error) {
    return key;  // Remove console.error, just return the key
  }
};

export default translations;
